import React from 'react';
import { ListItem, Menu } from '../DefaultMenu/styles';
import newsIcon from '../../assets/images/news_menu_item.svg';
import cameraIcon from '../../assets/images/camera_menu_item.svg';
import { NavLink } from 'react-router-dom';
import { Portal } from '@mui/material';
import { usePortalContext } from 'common/PortalContext';

const MediaMenu: React.FC = () => {
  const PortalContext = usePortalContext();
  const midiaKitURL = PortalContext?.midiaKitURL;

  return (
    <Menu>
      <ul>
        <ListItem>
          <NavLink exact activeClassName="selected" to="/news">
            <img src={newsIcon} alt="icon for list item" />
            <span>Notícias e Mídias Sociais</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <a href={midiaKitURL} target="_blank" rel="noopener noreferrer">
            <img src={cameraIcon} alt="icon for list item" />
            <span>Mídia Kit</span>
          </a>
        </ListItem>
      </ul>
    </Menu>
  );
};

export default MediaMenu;
